import { useMemo } from 'react';
import { useAuthStore } from '@indipia/shared';
import { useWorklogStore } from '../../store/worklogStore';
import type { BasicInfoPartner } from '../../types/worklog.types';
import { OWNER_AUTHOR_ID } from './feedModel';

/**
 * 공사현황 피드의 작성자 필터 목록 — worklogStore 의 작성자 후보(시공+자재 파트너) 재사용(직접 조회 안 함).
 * 현장보고는 로그인 사장님(OWNER)도 작성하므로, 작성자 목록 맨 앞에 로그인 사용자를 추가한다(현장보고 목록과 동일).
 * 로딩 전이면 partners=null.
 */
export function useFeedPartners() {
  const storePartners = useWorklogStore((s) => s.reportWriters);
  const storeStatus = useWorklogStore((s) => s.status);
  const partnersLoaded = storeStatus === 'ready' || storeStatus === 'error';
  const authUser = useAuthStore((s) => s.user);
  const partners = useMemo<BasicInfoPartner[] | null>(() => {
    if (!partnersLoaded) return null;
    if (!authUser) return storePartners;
    // 로그인 사장님 pseudo — partnerId 대신 음수 sentinel(OWNER_AUTHOR_ID)로 식별. 맨 앞에 배치.
    const ownerOption: BasicInfoPartner = {
      partnerId: OWNER_AUTHOR_ID,
      partnerName: `${authUser.memberName} (나)`,
      partnerPhone: null,
      email: null,
      workTypeCodes: null,
    };
    return [ownerOption, ...storePartners];
  }, [partnersLoaded, authUser, storePartners]);

  return { partners, partnersLoaded, partnersError: storeStatus === 'error' };
}
